import modernHydrateClient from '@eversports/react-app-base/modern-hydrate-client'

import App from '../../App'
import fragmentTypes from '../../graphql-checkout-possible-types'
import getLocalizationProvider from '../LocalizationProvider'

modernHydrateClient({
  App,
  getLocalizationProvider,
  apolloOptions: {
    possibleTypes: fragmentTypes.possibleTypes,
    uri: '/api/checkout',
    typePolicies: {
      Query: {
        fields: {
          venue: {
            read(_, { args, toReference }) {
              return toReference({
                __typename: 'Venue',
                id: args?.venueId,
              })
            },
          },
          match: {
            read(_, { args, toReference }) {
              return toReference({
                __typename: 'BallsportMatch',
                id: args?.matchId,
              })
            },
          },
        },
      },
    },
  },
}).catch((error) => console.error(error))
